import _ from 'lodash';
import { debugLogger } from '@ichef/fe-utils';

const ONLINE_RESTAURANT = 'onlineRestaurant';
const INSTORE_ORDERING = 'instoreOrdering';
const RESERVATION = 'reservation';
const STORE_BROWSER = 'storeBrowser';

const onlineRestaurantSentEvents = new Set();
const instoreSentEvents = new Set();
const reservationSentEvents = new Set();

export function sendGaEvent(event, parameters, target) {
  if (!_.isFunction(window.gtag)) {
    debugLogger.warn('gtag is not initialized correctly. Please check again.');
    return;
  }

  if (!_.isString(event)) {
    debugLogger.warn('The type of event should be string');
    return;
  }

  if (parameters && !_.isObject(parameters)) {
    debugLogger.warn('The type of parameters should be object');
    return;
  }

  if (parameters) {
    window.gtag('event', event, {
      ...parameters,
      send_to: target,
    });
  } else {
    window.gtag('event', event, {
      send_to: target,
    });
  }
}

export const sendGaEventToOnlineRestaurant = (event, parameters) => {
  sendGaEvent(event, parameters, ONLINE_RESTAURANT);
  onlineRestaurantSentEvents.add(event);
};

export const sendGaEventToOnlineRestaurantOnce = (event, parameters) => {
  if (onlineRestaurantSentEvents.has(event)) {
    return;
  }
  sendGaEventToOnlineRestaurant(event, parameters);
};

export const sendGaEventToInstoreOrdering = (event, parameters) => {
  sendGaEvent(event, parameters, INSTORE_ORDERING);
  instoreSentEvents.add(event);
};

export const sendGaEventToInstoreOrderingOnce = (event, parameters) => {
  if (instoreSentEvents.has(event)) {
    return;
  }
  sendGaEventToInstoreOrdering(event, parameters);
};

export const sendGaEventToReservation = (event, parameters) => {
  sendGaEvent(event, parameters, RESERVATION);
  reservationSentEvents.add(event);
};

export const sendGaEventToReservationOnce = (event, parameters) => {
  if (reservationSentEvents.has(event)) {
    return;
  }
  sendGaEventToReservation(event, parameters);
};

export const sendGaEventToStoreBrowser = (event, parameters) =>
  sendGaEvent(event, parameters, STORE_BROWSER);
